import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const TemplateWithInfoWrapperTabletStyles = media.tablet`
  flex-direction: column-reverse;
`;

export const ScrollableContentWrapperTabletStyles = media.tablet`
  flex: 1;
  display: flex;
  align-content: stretch;
  &:after,
  &:before {
    display: none;
  }
`;

const TemplateWithInfoWrapper = styled.div`
  flex: 1;
  display: flex;
  width: 100vw;
  height: 100vh;
  ${TemplateWithInfoWrapperTabletStyles};
`;

export const ScrollableContentWrapper = styled.div`
  position: relative;
  &:after,
  &:before {
    width: 100%;
    content: '';
    display: block;
    position: absolute;
    z-index: 1;
    left: 0;
  }

  &:after {
    height: 80px;
    bottom: 0;
    background-image: linear-gradient(
      180deg,
      rgba(235, 238, 245, 0) 0%,
      #ebeef5 100%
    );
  }
  &:before {
    height: 50px;
    top: 0;
    background-image: linear-gradient(
      180deg,
      #ebeef5 0%,
      rgba(235, 238, 245, 0) 100%
    );
  }
  &:hover {
    &:after,
    &:before {
      display: none;
    }
  }
  ${ScrollableContentWrapperTabletStyles};
`;

export default TemplateWithInfoWrapper;
